import { AffordabilityRequest, BtlAffordabilityRequest, ClientDetails, ProductLengthExtended, ProductType, RateType } from '@shared/models';

export enum SsoCallBackEventType
{
  Sourcing,
  Affordability,
}

export interface CurrentProduct {
  lender: string;
  endDate: Date;
}

interface CustomRange {
  fromMonths: number;
  toMonths: number;
}

export interface InitialPeriod {
  productLength?: ProductLengthExtended[];
  customRange?: CustomRange;
}

export interface ProductCaseData {
  productType?: ProductType;
  currentProduct: CurrentProduct;
  purchasePriceShare?: number;
  discountedPurchasePrice?: number;
  additionalBorrowing?: boolean;
  rateType?: RateType[];
  initialPeriod?: InitialPeriod;
}

export interface SsoCallbackAuth
{
  bearer?: string;
}

export interface SsoCallbackEvent
{
  callbackUrl: string;
  authorization: SsoCallbackAuth;
  customData: string;
  eventType: SsoCallBackEventType;
}

export interface CaseData {
  reference: string;
  affordabilityInput : AffordabilityRequest | BtlAffordabilityRequest;
  productInput?: ProductCaseData;
  clientDetails: ClientDetails;
  sourcingCallBack: boolean;
  organisationId: string;
  events?: SsoCallbackEvent[];
  lenderMatched: boolean;
  caseId: string | null;
}
